import { useSelector } from "react-redux";

import { DataTable } from "../../../components/DataTable";
import {
  setCollectionYardVisitEventsPagination,
  setCollectionYardVisitEventsScrollTop,
} from "../../../reducers/collectionYardVisitEventsReducer";
import {
  getCollectionYardVisitEvents,
  getCollectionYardVisitEventsList,
  getIsCollectionYardVisitEventsStatusLoading,
} from "../../../selectors/collectionYardVisitEvents";
import { useGetCollectionYardVisitEventsTableColumns } from "./useGetCollectionYardVisitEventsTableColumns";

import styles from "./CollectionYardVisitEventsTable.module.scss";

export const CollectionYardVisitEventsTable: React.FC = () => {
  const data = useSelector(getCollectionYardVisitEventsList);
  const columns = useGetCollectionYardVisitEventsTableColumns();
  const isLoading = useSelector(getIsCollectionYardVisitEventsStatusLoading);
  const CollectionYardVisitState = useSelector(getCollectionYardVisitEvents);

  return (
    <DataTable
      className={styles.tableContent}
      dataRows={data}
      columns={columns}
      scrollTop={0}
      setScrollTop={setCollectionYardVisitEventsScrollTop}
      setPagination={setCollectionYardVisitEventsPagination}
      isLoading={isLoading}
      sliceState={CollectionYardVisitState}
      getRowId={(row) => row.collectionYardEventId}
    />
  );
};
